import { StarMark } from "@/components/Logo";

const ITEMS = [
  "Healthcare systems",
  "Enterprise tech",
  "Finance & fintech",
  "Media & streaming",
  "Marketing ops",
  "Sales plan execution",
  "AI project implementation",
  "Urgent & last-minute PM support",
];

export default function Marquee() {
  const row = (ariaHidden) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-mono text-xs uppercase tracking-[0.3em] text-slate-500 sm:text-sm">
            {item}
          </span>
          <StarMark className="h-3 w-3 shrink-0 text-gold/70" />
        </span>
      ))}
    </div>
  );

  return (
    <div className="marquee relative overflow-hidden border-y border-white/8 bg-abyss/50 py-6">
      <div className="marquee-track flex w-max">
        {row(false)}
        {row(true)}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-obsidian to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-obsidian to-transparent" />
    </div>
  );
}
